export default "__VITE_ASSET__DJ7UxX2N__"